<realwear-cloud-top-bar></realwear-cloud-top-bar>

<realwear-cloud-nothing-here
  >Oops, it looks like you've searched for an app that doesn't exist
</realwear-cloud-nothing-here>

<p class="select_category">Select a category to explore our App Marketplace</p>

<div class="nav-buttons">
  <nav>
    <a
      *ngFor="let category of categories"
      [attr.data-testid]="category"
      class="nav-button"
      mat-ripple
      routerLink="/browse/{{ category }}"
      routerLinkActive="selected">
      {{ category | categoryName }}
    </a>
  </nav>
</div>
